import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import Background from "../../../assets/images/search-icon.png"
import useMediaQuery from '@mui/material/useMediaQuery';

const Search = ({ list = [], filterData, encoded = false, placeholder = "Search Patient...", formik}) => {
    const [searchVal, setSearchVal] = useState(formik?.nameFilter || "");
    const filter = () => {
        const data = (searchVal.trim().length > 0) ? list?.filter((data) => (data?.patient?.display?.toLowerCase()?.includes(searchVal))) : list;
        filterData(data);
    }
    const isSmallScreen = useMediaQuery('(max-width: 991px)');
    const isBigScreen = useMediaQuery('(max-width: 1395px)');
    useEffect(() => {
        filter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchVal, list])
    return (
        <Form className="search-wrap">
            <Form.Control
                type="search"
                placeholder={placeholder}
                className="me-2"
                aria-label="Search"
                // style={{ backgroundImage: searchVal ? "none" : `url(${Background})`, height: "50px", borderRadius: "10px", borderColor: "rgb(204,204,204)", borderWidth: "1px", borderStyle: "solid", width: "200px", marginRight: "2px", backgroundColor: "white" }}
                style={{backgroundImage: searchVal ? "none" : `url(${Background})`, backgroundColor: "white", borderRadius: "10px", borderColor: "rgb(204,204,204)", borderWidth: "1px", borderStyle: "solid", height: "42px",minHeight:isBigScreen ? "54px": "50px",maxWidth: "200px" }}
                value={searchVal}
                onChange={(e) => { 
                    setSearchVal(e.target.value.toLowerCase()); 
                    formik.setFieldValue("nameFilter", e.target.value.toLowerCase())
                }}
            />
        </Form>
    )
}

export default Search